var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-icon tt-out-of-stock-icon"},[_c('img',{attrs:{"src":require("@/assets/icons-new/out-of-stock.png"),"alt":"out-of-stock"}}),_c('div',{staticClass:"tt-tooltip"},[_vm._v(" "+_vm._s(_vm.$t('OrderPage_cmpt_OrderCart_error_samovivoz_product'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }